$(document).ready(function() {
  /*svg*/
  jQuery('img.svg').each(function(){
    var $img = jQuery(this);
    var imgID = $img.attr('id');
    var imgClass = $img.attr('class');
    var imgURL = $img.attr('src');

    jQuery.get(imgURL, function(data) {
      // Get the SVG tag, ignore the rest
      var $svg = jQuery(data).find('svg');

      // Add replaced image's ID to the new SVG
      if(typeof imgID !== 'undefined') {
        $svg = $svg.attr('id', imgID);
      }
      // Add replaced image's classes to the new SVG
      if(typeof imgClass !== 'undefined') {
        $svg = $svg.attr('class', imgClass+' replaced-svg');
      }

      // Remove any invalid XML tags as per http://validator.w3.org
      $svg = $svg.removeAttr('xmlns:a');

      // Check if the viewport is set, if the viewport is not set the SVG wont't scale.
      if(!$svg.attr('viewBox') && $svg.attr('height') && $svg.attr('width')) {
        $svg.attr('viewBox', '0 0 ' + $svg.attr('height') + ' ' + $svg.attr('width'))
      }

      // Replace image with new SVG
      $img.replaceWith($svg);

    }, 'xml');

  });

  if($(".profile__header-sl").length>0){
    $(".profile__header-sl").slick({
      slidesToShow: 6,
      slidesToScroll: 1,
      rows: 1,
      slidesPerRow:1,
      //autoplay: true,
      autoplaySpeed: 3500,
      infinite:false,
      arrows: true,
      dots: false,
      speed:800,
      pauseOnHover: true,
      focusOnSelect: true,
      /*prevArrow: prev,
      nextArrow: next,*/
      pauseOnDotsHover: true,
      variableWidth:true,
      responsive: [{
        breakpoint: 768,
        settings: {
          rows: 3,
          slidesPerRow:3,
          slidesToShow: 1,
          variableWidth:true,
          // slidesToShow: 3,
        }
      }]
    });
  }


  /*select*/
  if( $('select').length>0){
    $('.select-city').selectize({
      create: false,
      sortField: false, //'text'
      valueField: 'url',
      labelField: 'name',
      searchField: 'name',
      onDropdownOpen: function() {
        $('.selectize-dropdown').mCustomScrollbar({
          theme: 'dark-3',
          axis: 'y',
        })
      }
    });
    $('.select-rating').selectize({
      create: false,
      sortField: false, //'text'
      valueField: 'url',
      labelField: 'name',
      searchField: 'name',
      onDropdownOpen: function() {
        $('.selectize-dropdown').mCustomScrollbar({
          theme: 'dark-3',
          axis: 'y',
        })
      }
    });

    $('.courses-header__sort-select').selectize({
      create: false,
      sortField: false, //'text'
      valueField: 'url',
      labelField: 'name',
      searchField: 'name',
      onDropdownOpen: function() {
        $('.selectize-dropdown').mCustomScrollbar({
          theme: 'dark-3',
          axis: 'y',
        })
      }
    });

    $('.courses-header__lang-select').selectize({
      create: false,
      sortField: false, //'text'
      valueField: 'url',
      labelField: 'name',
      searchField: 'name',
      onDropdownOpen: function() {
        $('.selectize-dropdown').mCustomScrollbar({
          theme: 'dark-3',
          axis: 'y',
        })
      }
    });
  }
  if($(".order-table").length > 0){
    $('.order-table').mCustomScrollbar({
      theme: 'dark-3',
      axis: 'x',
    })
  }

  //tabs
  if ($(".basket-registration__tab-list").length>0) {
    $('ul.basket-registration__tab-list li').click(function(){
      var tab_id = $(this).attr('data-tab');

      $('ul.basket-registration__tab-list li').removeClass('current');
      $('.basket-registration__tab-content').removeClass('current');

      $(this).addClass('current');
      $("#"+tab_id).addClass('current');


    })
  }

  $(".modal-alert__close").click(function () {
    $(this).closest(".modal-alert").removeClass("visible");
  });



  /*password*/
  $('body').on('click', '.form-password__control', function(){
    if ($(this).closest(".form-password").find('.password-input').attr('type') == 'password'){
      $(this).addClass('view');
      $(this).closest(".form-password").find('.password-input').attr('type', 'text');
    }
    else {
      $(this).removeClass('view');
      $(this).closest(".form-password").find('.password-input').attr('type', 'password');
    }
    return false;
  });

  /*menu close*/
  if($(".menu__close").length>0){
    $(".menu__close").on("click", function () {
      $(this).closest(".menu").toggleClass("js-open");
      $(this).closest(".container").find(".content-wrap").toggleClass("js-menu-open");
    })
  }
  /*profile*/
  if($(window).width() >= 992 && $(".header-st__profile").length>0){
    $(".header-st__profile").mouseover(function() {
      $(this).find(".header-st__profile-desc").stop().addClass("js-open");
      $(this).closest(".content-wrap").stop().addClass("js-profile-open");
    });
    $(".header-st__profile").mouseleave(function() {
      $(this).find(".header-st__profile-desc").stop().removeClass("js-open");
      $(this).closest(".content-wrap").stop().removeClass("js-profile-open");
    });
  }
  /*menu mobile*/
  if($(window).width() <= 991 && $(".header-st__menu-toggle").length>0){
    $(".header-st__menu-toggle").click(function () {
      $("body").addClass("js-mobmenu-open");
      $("body").find(".menu").addClass("js-mobmenu-open");
    });
    $(".menu__close-menu").click(function () {
      $("body").removeClass("js-mobmenu-open");
      $("body").find(".menu").removeClass("js-mobmenu-open");
    })

    jQuery(function($){
      $(document).mouseup(function (e){
        var divmenu = $(".menu");
        if (!divmenu.is(e.target)
          && divmenu.has(e.target).length === 0) {
          divmenu.closest("body").removeClass("js-mobmenu-open");
          divmenu.removeClass("js-mobmenu-open");

        }
      });
    });
  }

  /*progress photo height*/
  function onResize() {
    var el = $('.progress-c__photo');
    el.height(el.width());
  }
  $(window).resize(onResize);
  $(document).ready(onResize);


  if($(".phone").length >0){
    var input = document.querySelector(".phone");
    window.intlTelInput(input, {
      // allowDropdown: false,
      // autoHideDialCode: false,
      // autoPlaceholder: "off",
      // dropdownContainer: document.body,
      // excludeCountries: ["us"],
      // formatOnDisplay: false,
      // geoIpLookup: function(callback) {
      //   $.get("http://ipinfo.io", function() {}, "jsonp").always(function(resp) {
      //     var countryCode = (resp && resp.country) ? resp.country : "";
      //     callback(countryCode);
      //   });
      // },
      // hiddenInput: "full_number",
      // initialCountry: "auto",
      // localizedCountries: { 'de': 'Deutschland' },
      // nationalMode: false,
      // onlyCountries: ['us', 'gb', 'ch', 'ca', 'do'],
      // placeholderNumberType: "MOBILE",
      // preferredCountries: ['cn', 'jp'],
      // separateDialCode: true,
      //utilsScript: "build/js/utils.js",
    });
  }
  if($(".faq__item-title").length >0){
    ! function(i) {
      var o, n;
      i(".faq__item-title").on("click", function() {
        o = i(this).parents(".faq__item"), n = o.find(".faq__item-content"),
          o.hasClass("active_block") ? (o.removeClass("active_block"),
            n.slideUp()) : (o.addClass("active_block"), n.stop(!0, !0).slideDown(),
            o.siblings(".active_block").removeClass("active_block").children(
              ".faq__item-content").stop(!0, !0).slideUp())
      });
    }(jQuery);
  }



});























